import ProfileHeader from "@/components/features/user-profile/profile-header";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { getBenefits } from "@/lib/constants";
import type { ProfileViewModel } from "@/lib/types";
import { Link, useOutletContext } from "react-router";

export default function Vouching() {
	const profile = useOutletContext<ProfileViewModel>();

	return (
		<section className="relative z-10 mx-auto flex max-w-4xl flex-col gap-5 px-6 py-24 sm:gap-10">
			<ProfileHeader profile={profile} label="Vouch Request" />
			<Separator />

			<div className="animate-screen flex flex-col gap-6 ">
				<h3>{profile.FirstName} picked you</h3>

				<ul className="space-y-3">
					{getBenefits(profile.Gender).map(
						({ icon: Icon, title, description }) => (
							<li key={title} className="flex gap-4">
								<Icon
									className="mt-0.5 size-5 shrink-0 text-muted-foreground"
									aria-hidden="true"
								/>
								<div>
									<p className="text-sm font-medium text-foreground">{title}</p>
									<p className="text-sm leading-relaxed text-muted-foreground">
										{description}
									</p>
								</div>
							</li>
						),
					)}
				</ul>
				<div className="flex flex-col gap-2">
					<Button size="xl" asChild>
						<Link to="qualify">Vouch for {profile.FirstName}</Link>
					</Button>
					<small className="text-center text-xs text-muted-foreground">
						By continuing, you agree to our{" "}
						<Link to="/terms-and-conditions" className="text-[#6e7ce6]">
							Terms & Conditions
						</Link>{" "}
						and{" "}
						<Link to="/privacy-policy" className="text-[#6e7ce6]">
							Privacy Policy
						</Link>
						.
					</small>
				</div>
			</div>
		</section>
	);
}
